import {Component, ChangeDetectionStrategy, Input, OnInit} from '@angular/core';
import {AudioService} from '../../../services/audio/audio.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-grapheme-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule
  ],
  templateUrl: './grapheme-item.component.html',
  styleUrls: ['./grapheme-item.component.scss']
})
export class GraphemeItemComponent implements OnInit {

  @Input() grapheme: any;
  @Input() type: string;

  constructor(
    public audioSrv: AudioService,
    public langTgtSrv: LangTgtService
  ) {
  }

  trackByIndex(index: number) { return index; }

  ngOnInit() {
  }
}
